export const statisticsConstants = {
  SET_STATS_REQUEST: 'SET_STATS_REQUEST',
  SET_STATS_SUCCESS: 'SET_STATS_SUCCESS',
  SET_STATS_FAILURE: 'SET_STATS_FAILURE',

  SET_STATS_TABS_SUCCESS: 'SET_STATS_TABS_SUCCESS',
  SET_STATS_TABS_FAILURE: 'SET_STATS_TABS_FAILURE',

  SET_STATS_DICTIONARY_SUCCESS: 'SET_STATS_DICTIONARY_SUCCESS',
  SET_STATS_DICTIONARY_FAILURE: 'SET_STATS_DICTIONARY_FAILURE',

  SET_STATS_FILTERS_SUCCESS: 'SET_STATS_FILTERS_SUCCESS',
  SET_STATS_FILTERS_FAILURE: 'SET_STATS_FILTERS_FAILURE',
  RESET_STATS_FILTERS: 'RESET_STATS_FILTERS',

  SET_WEBMASTER_PRESETS_SUCCESS: 'SET_WEBMASTER_PRESETS_SUCCESS',
  SET_WEBMASTER_PRESETS_FAILURE: 'SET_WEBMASTER_PRESETS_FAILURE',

  CREATE_WEBMASTER_PRESET_SUCCESS: 'CREATE_WEBMASTER_PRESET_SUCCESS',
  CREATE_WEBMASTER_PRESET_FAILURE: 'CREATE_WEBMASTER_PRESET_FAILURE',

  UPDATE_WEBMASTER_PRESET_SUCCESS: 'UPDATE_WEBMASTER_PRESET_SUCCESS',
  UPDATE_WEBMASTER_PRESET_FAILURE: 'UPDATE_WEBMASTER_PRESET_FAILURE',

  REMOVE_WEBMASTER_PRESET_SUCCESS: 'REMOVE_WEBMASTER_PRESET_SUCCESS',
  REMOVE_WEBMASTER_PRESET_FAILURE: 'REMOVE_WEBMASTER_PRESET_FAILURE',
  
  SET_CURRENT_TAB: 'SET_CURRENT_TAB',
};
